import { useSubmissionAnalyticsMutation } from '@graphql/mutations/__generated__/submission-analytics.generated'
import React, { useEffect } from 'react'
import { QueryParamConfig, StringParam, useQueryParams } from 'use-query-params'

export type TAnalyticsEvent = 'open' | 'click'

export const AnalyticsParams = {
  event: StringParam as QueryParamConfig<TAnalyticsEvent | null>,
  submission: StringParam,
  activation_code: StringParam,
}

interface IAnalyticsProps {}

const Analytics: React.FC<IAnalyticsProps> = () => {
  const [params, setParams] = useQueryParams(AnalyticsParams)
  const [submissionAnalyticsMutate] = useSubmissionAnalyticsMutation({
    variables: {
      event: params.event,
      submission: params.submission,
      activationCode: params.activation_code,
    },
    onCompleted: () => {
      setParams(
        { activation_code: undefined, submission: undefined, event: undefined },
        'replaceIn'
      )
    },
    onError: () => {
      setParams(
        { activation_code: undefined, submission: undefined, event: undefined },
        'replaceIn'
      )
    },
    ignoreResults: true,
    notifyOnNetworkStatusChange: true,
  })
  useEffect(() => {
    if (params.event) {
      submissionAnalyticsMutate()
    }
  }, [params.event])

  return null
}

export default Analytics
